export default "__VITE_ASSET__BnUafsK8__"